import React, { useEffect, useState } from 'react';
import DialogModal from '../../../Modal/DialogModal/DialogModal';
import TabGallery from '../../../Tabs/Components/TabGallery/TabGallery';
import useWindowResize from 'hooks/useWindowResize';
import './HotspotModal.scss';
import { getTypeLabel } from "../../../../utils/accessibilityHelpers";

const HotspotModal = ({
  autoPlay,
  closeModal,
  content,
  alt,
  hotspotId,
  hotspotName,
  img,
  media,
  name,
  primaryColor = '#009c66',
  showModal,
  src,
  tourId,
  tourName,
  transcript,
  type,
  isBeingEdited = false,
}) => {
  const [styles, setStyles] = useState({});
  const windowSize = useWindowResize('a-canvas');
  const isFullscreen = 
    document.fullscreen || 
    document.webkitCurrentFullScreenElement || 
    document.mozFullScreenElement || 
    document.msFullscreenElement;

  useEffect(() => {
    if (Object.keys(windowSize).length !== 0) {
      const height = isBeingEdited
        ? parseInt(windowSize.height) - 48 + 'px'
        : windowSize.height;
      setStyles({
        overlay: {
          width: windowSize.width,
          height: height,
          top: 'auto',
          left: 'auto',
        },
      });
    }
  }, [isBeingEdited, showModal, windowSize]);

  return (
    <div
      className="hotspot-media-modal__wrapper"
      data-testid="hotspot-modal"
    >
      <DialogModal
        className="hotspot-media-modal"
        closeModal={closeModal}
        isOpen={showModal}
        shouldCloseOnOverlayClick
        styles={styles}
        // The parent element needs to be the scene element when in fullscreen mode
        // Otherwise, the modal will be rendered outside of the scene element
        // But as of 8/11/2025 voiceover cannot enter the modal when the parent element
        // is the scene element. So this is a workaround to allow voiceover to enter the modal
        // when not in fullscreen mode.
        parentElement={isFullscreen ? document.querySelector('#scene') : undefined}
        aria={{
          label: `${getTypeLabel(type)} hotspot modal`,
        }}
      >
        <article id="hotspot-media-modal__title-wrapper">
          {!!name && <h4 className="hotspot-media-modal__name">{name}</h4>}
          <div id="hotspot-media-modal__media-wrapper" className={type}>
            <TabGallery
              autoPlay={autoPlay}
              media={[
                {
                  id: hotspotId,
                  alt,
                  type,
                  content,
                  src,
                  img,
                  tracks: media,
                  transcript,
                },
              ]}
              tourId={tourId}
              tourName={tourName}
              primaryColor={primaryColor}
              hotspotName={hotspotName}
            />
          </div>
        </article>
      </DialogModal>
    </div>
  );
};

export default HotspotModal;
